import React from 'react';
import { Helmet } from 'react-helmet';
import AIheader from '../RentAI/AIheader';
import Footer from '../../Component/Footer/Footer';
import HeroSection from '../../Component/IcrsEvent/HeroSection';
import AboutSection from '../../Component/IcrsEvent/AboutSection';
import ProductSection from '../../Component/IcrsEvent/ProductSection';
import '../../Component/IcrsEvent/IcrsEvent.css';

// ICRS 2026 event landing page (Booth 400, Dallas, TX).
// Uses the site-standard header (AIheader) and Footer; the page body is the
// ported ICRS content sections.
const IcrsEvent = () => (
  <>
    <Helmet>
      <title>Rentid at ICRS 2026 — Booth 400 | Dallas, TX</title>
      <meta
        name="description"
        content="Visit Rentid at the International Car Rental Show 2026 in Dallas, TX, May 13–15 at Booth 400. See RentDirect™ and RentID™ in action."
      />
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      <link
        href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap"
        rel="stylesheet"
      />
    </Helmet>

    <AIheader />

    <div className="icrs-event">
      <HeroSection />
      <AboutSection />
      <ProductSection />
    </div>

    <Footer />
  </>
);

export default IcrsEvent;
